import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { MyPreset } from '../theme/mytheme';
import { globalHttpInterceptors } from './core/interceptor/interceptors';
import { StoreModule } from '@ngrx/store';

// noinspection TypeScriptValidateTypes
export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),

    {
      provide: LOCALE_ID,
      useValue: 'es-ES',
    },

    // Theming
    provideAnimationsAsync(),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: MyPreset,
        options: {
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng',
          },
          darkModeSelector: '.my-app-dark',
        },
      },
    }),

    provideHttpClient(withInterceptors(globalHttpInterceptors)),

    // Rutas standalone
    provideRouter(routes),

    // Otros módulos que no sean standalone
    importProvidersFrom(StoreModule.forRoot({})),
  ],
};
